import { useTranslation } from "react-i18next";
import SvgIcon from "../SvgIcon";

// "Drag to reposition · scroll or pinch to zoom". `pill` renders it as the
// blue info badge used when the hint sits on its own row above the stage;
// without it, it is the plain muted line that sits under the toolbar.
const AlignHint = ({ pill }) => {
  const { t } = useTranslation("athlete-portal");

  if (!pill) {
    return (
      <span className="compare-align-hint">
        {t("questionProgress.alignHint")}
      </span>
    );
  }

  return (
    <span className="compare-align-hint as-pill">
      <SvgIcon
        src="/img/new-icons/info-circle.svg"
        useCurrentColor
        style={{ width: "1rem", height: "1rem" }}
      />
      {t("questionProgress.alignHint")}
    </span>
  );
};

export default AlignHint;
